import React, { useContext, useEffect, useState } from 'react';
import { Dialog } from '@tencent/spaui';
import Home from './HelpHomePage';
import Menu from './HelpContentsPage';
import Detail from './HelpDetail';
import { RPCFactory } from '../../../utils/RequestUtil';
import { Context, Provider, ACTIONS } from './store';
/**
 * icons
 * icon-helptab-xiansuo
 * icon-helptab-huihua
 * icon-helptab-fans
 * icon-helptab-shezhi
 * icon-helptab-normal
 */

const HelperTool = {
  getStoreKey() {
    return '_cache_leads_helper_config';
  },
  load() {
    const key = this.getStoreKey();
    try {
      const cache = window.localStorage.getItem(key);
      if (!cache) throw new Error('no cache');
      return JSON.parse(cache);
    } catch(e) {
      return [];
    }
  },
  store(config) {
    const key = this.getStoreKey();
    const cache = JSON.stringify(config);
    window.localStorage.setItem(key, cache);
  },
};

const Helper = ({ config }) => {
  const { state } = useContext(Context);
  const { menuItem, detailItem } = state;

  switch (state.type) {
    case 'home':
      return (<Home config={config} />);
    case 'menu':
      return (<Menu id={menuItem.id} />);
    case 'detail':
      return (<Detail id={detailItem.id} />);
    default:
      return null;
  }
};

const HelpDialog = (props) => {
  const [config, setConfig] = useState(HelperTool.load());
  const { dispatch } = useContext(Context);

  const handleClose = () => {
    if (typeof props.hideQuickHelp !== 'function') return;
    props.hideQuickHelp();
  };

  useEffect(() => {
    window._quick_jump_to_risk_warning = () => {
      dispatch({ type: ACTIONS.JUMP_TO_RISK_WARNING });
      const setData = resData => dispatch({
        type: ACTIONS.SET_MENU_DATA,
        payload: resData,
      });
      RPCFactory.quickHelp
        .getCatalog(2381)
        .done(setData)
        .fail((_, msg) => alert(msg));
    };
  }, [dispatch]);

  useEffect(() => {
    const { uid } = window.pageProps;
    const configUrl = `https://v.qq.com/cache/wuji_public/object?appid=leadswebtest&schemaid=helper&schemakey=8f0b1de096a14cc7ac85a6f3a3e03d64&accountId=${uid}`;
    fetch(configUrl)
      .then(res => res.json())
      .then(({ data }) => {
        const config = data.map((item) => ({
          title: item.title,
          icon: item.icon,
          id: item.id,
          items: JSON.parse(item.items),
        }));
        setConfig(config);
        HelperTool.store(config);
      })
      .catch((e) => console.log('config fetch failed', e.message));
  }, []);

  return (
    <Dialog
      uncover
      animation
      hideFooter
      title=""
      position="right"
      modalClassName="no-cover"
      className="with-full-height modal-lead-help"
      style={{ width: 500 }}
      show={props.show}
      onClose={handleClose}
      onSubmit={handleClose}
      onCancel={handleClose}
    >
      <div className="fast-help-modal">
        <div className="dialog-title">
          <div>
            <h2 className="dialog-title-name">快捷帮助</h2>
          </div>
        </div>
        <Helper config={config} />
      </div>
    </Dialog>
  );
};

export default (props) => (
  <Provider>
    <HelpDialog {...props} />
  </Provider>
);
